module.exports = __webpack_public_path__ + "static/img/21-0623-detail4.658c8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/21-0623-detail4.jpg
// module id = nLyu
// module chunks = 0